import React from "react";
import { Controller } from "react-hook-form";
import { EquipmentDataEdit } from "../../../types/api/equipment";
import { Box, InputAdornment, TextField } from "@mui/material";
import PhotoUpload from "../../../components/PhotoUpload/PhotoUpload";
import { EditFormProps } from "../../../types/common";
import { MoneyField } from "../../../components/UI/MoneyField/MoneyField";

const EditContent = ({ form }: EditFormProps<EquipmentDataEdit>) => {
    return (
        <Box
            component="form"
            sx={{
                "& .MuiTextField-root": { my: 1 },
            }}
            noValidate
            autoComplete="off">
            <Controller
                defaultValue={""}
                name="name"
                control={form.control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label={"Наименование"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                control={form.control}
                name="start_date"
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        type="date"
                        fullWidth
                        label="Ввод в эксплуатацию"
                        onChange={(e: any) => {
                            onChange(e.target.value.replace(/-/g, "/"));
                        }}
                        value={value?.slice(0, 10).replace(/\//g, "-")}
                        autoComplete="off"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                control={form.control}
                name="date"
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        type="date"
                        fullWidth
                        label="Дата выпуска"
                        onChange={(e: any) => {
                            onChange(e.target.value.replace(/-/g, "/"));
                        }}
                        value={value?.slice(0, 10).replace(/\//g, "-")}
                        autoComplete="off"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                name="count"
                control={form.control}
                render={({ field: { value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        fullWidth
                        label={"Кол-во"}
                        type={"number"}
                        value={value || ""}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">ед.</InputAdornment>,
                        }}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <MoneyField name={"cost"} control={form.control} label={"Закупочная стоимость"} />
            <Controller
                name="photos"
                control={form.control}
                render={({ field: { value }, fieldState }) => {
                    return <PhotoUpload error={fieldState.error} field={{ photos: value }} setValue={form.setValue} />;
                }}
            />
        </Box>
    );
};

export default EditContent;
